type Props = {
    className?: string;
};

export default function NoResultsIcon({ className }: Props) {
    return (
        <svg
            className={className}
            width="40"
            height="40"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="10" cy="10" r="7" />
            <line x1="21" y1="21" x2="15.65" y2="15.65" />
            <line x1="7.8" y1="7.8" x2="12.2" y2="12.2" />
            <line x1="12.2" y1="7.8" x2="7.8" y2="12.2" />
        </svg>
    );
}
